module.exports = "/assets/dd52d3b51176f08fb4cbee66160fd6e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JL.png
// module id = 2638
// module chunks = 0